export function initTagList(form, input) {
    const tagList = form.querySelector('.js-tag-list');
    const fakeInput = form.querySelector('.js-fake-input');
    const errorMessage = form.querySelector('.js-error-message');

    const CLOSE_BUTTON_CLASS = 'tag-list__close-button';
    const TAG_LIST_CLASS = 'tag-list__list-item';

    function resetFakeInputValue() {
        fakeInput.value = null;
    }

    function deleteElement(elementToDelete) {
        if (elementToDelete) {
            elementToDelete.remove();
            updateHiddenInputValue(elementToDelete.textContent);
        }
    }

    function targetElementToDelete() {
        const tagListItem = document.querySelectorAll('.' + TAG_LIST_CLASS);

        if (!fakeInput.value) {
            deleteElement(tagListItem[tagListItem.length - 1]);
        }
    }

    function updateHiddenInputValue(listValue) {
        const filteredValues = input.value.split(',').filter((inputValue) => inputValue !== listValue);

        input.value = filteredValues.join(',');
    }

    function removeTagOnClickOnCloseIcon(list) {
        const closeIcon = list.querySelector('.' + CLOSE_BUTTON_CLASS);

        closeIcon.addEventListener('click', (e) => {
            deleteElement(e.currentTarget.closest('li'));
        });
    }

    function addCloseButtonToTag(list) {
        const closeButton = document.createElement('button');
        closeButton.classList.add(CLOSE_BUTTON_CLASS);
        list.appendChild(closeButton);
    }

    function transformInputValueToTag(value) {
        const listItem = document.createElement('li');
        listItem.textContent = value;
        listItem.classList.add(TAG_LIST_CLASS);
        tagList.appendChild(listItem);
        input.value += !input.value ? value : ',' + value;

        addCloseButtonToTag(listItem);
        removeTagOnClickOnCloseIcon(listItem);
    }

    function resetFakeInputPlaceholder() {
        if (input.value) {
            fakeInput.placeholder = '';
        } else {
            fakeInput.placeholder = Hop.message('company.member.invitation.placeholder');
        }
    }

    function createTagElement() {
        if (fakeInput.value !== '') {
            transformInputValueToTag(fakeInput.value);
            resetFakeInputValue();
        }
    }

    function isDuplicatedValue(listValue) {
        return input.value.split(',').includes(listValue);
    }

    function inputVerification() {
        const isValid = !fakeInput.checkValidity || fakeInput.checkValidity();

        if (isValid && !isDuplicatedValue(fakeInput.value)) {
            errorMessage.textContent = '';
            return true;
        } else if (!isValid) {
            errorMessage.textContent = fakeInput.validationMessage;
            return false;
        } else if (isDuplicatedValue(fakeInput.value)) {
            errorMessage.textContent = Hop.message('generic.duplicate.email.input.error');
            return false;
        }
    }

    function preventSubmitForm(e) {
        e.preventDefault();
        e.stopImmediatePropagation();
    }

    function checkWhichKeyIsPressed(e) {
        if (e.key === 'Enter' || e.key === ',') {
            preventSubmitForm(e);
            flushInput();
        } else if (e.key === 'Backspace') {
            targetElementToDelete();
        }

        resetFakeInputPlaceholder();
    }

    function flushInput() {
        if (inputVerification()) {
            createTagElement();
        }
    }

    function listenToUserAction() {
        fakeInput.addEventListener('keydown', checkWhichKeyIsPressed);
    }

    listenToUserAction();

    function onSubmit(e) {
        checkWhichKeyIsPressed(e);
    }

    function reset() {
        form.querySelectorAll('.' + TAG_LIST_CLASS).forEach((el) => deleteElement(el));
        resetFakeInputValue();
        resetFakeInputPlaceholder();
        input.value = null;
    }

    function flush() {
        flushInput();
    }

    return {onSubmit, reset, flush};
}
